/**
 * Reusable form primitives — pastel-editorial style.
 * Inputs share .wit-input classes; this file gives them labels & error display.
 */
export const Field = ({
  label,
  required = false,
  hint,
  error,
  children,
  testId,
  span = 1,
}) => (
  <label
    className={`flex flex-col gap-2 text-sm text-cocoa ${
      span === 2 ? "sm:col-span-2" : ""
    }`}
    data-testid={testId}
  >
    <span className="font-medium">
      {label}
      {required && <span className="text-raspberry"> *</span>}
    </span>
    {children}
    {hint && !error && (
      <span className="text-xs text-warmGrey leading-relaxed">{hint}</span>
    )}
    {error && (
      <span className="text-xs text-coral" role="alert">
        {error}
      </span>
    )}
  </label>
);

export default Field;
